import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import index from '@/components/index'
import guanwang from '@/components/guanwang/guanwang'
import guanwang2 from '@/components/guanwang/guanwang2'
import guanwang3 from '@/components/guanwang/guanwang3'
import guanwang4 from '@/components/guanwang/guanwang4'
import guanwang5 from '@/components/guanwang/guanwang5'
import guanwang6 from '@/components/guanwang/guanwang6'
import root from '@/components/guanli/root'
import role from '@/components/guanli/role'
import power from '@/components/guanli/power'
import htmlRoot from '@/components/guanli/htmlRoot'
import deathList from '@/components/guanli/deathList'
Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        component: login,
    }, {
        path: '/index',
        name: 'index',
        component: index,
        children: [{
            path: '/index',
            component: guanwang,
        }, {
            path: '/guanwang',
            component: guanwang,
        }, {
            path: '/guanwang2',
            component: guanwang2,
        }, {
            path: '/guanwang3',
            component: guanwang3,
        }, {
            path: '/guanwang4',
            component: guanwang4,
        }, {
            path: '/guanwang5',
            component: guanwang5,
        }, {
            path: '/guanwang6',
            component: guanwang6,
        }, {
            path: '/root',
            component: root,
        }, {
            path: '/role',
            component: role,
        }, {
            path: '/power',
            component: power,
        }, {
            path: '/htmlRoot',
            component: htmlRoot,
        }, {
            path: '/deathList',
            component: deathList,
        }, {
            path: '/coach',
            component: ()=>import('../components/guanwang/coach.vue'),
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js